import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  badge: {
    alignItems: 'center',
    backgroundColor: colors.primary.carnation,
    borderColor: colors.secondary.orchid,
    borderRadius: scale(7),
    borderWidth: 1,
    justifyContent: 'center',
    minHeight: scale(14),
    minWidth: scale(14),
    paddingHorizontal: scale(3),
    position: 'absolute',
    right: scale(5),
    top: scale(9),
  },
  badgeText: {
    color: colors.neutral.cotton,
    fontSize: scale(7),
    lineHeight: scale(8),
  },
  container: {
    alignItems: 'center',
    height: scale(40),
    justifyContent: 'center',
    marginRight: scale(2),
    minWidth: scale(40),
    paddingHorizontal: scale(8),
    position: 'relative',
  },
});

export default styles;
